import React, { useState, useEffect, useMemo } from "react";
import { ColumnsType } from 'antd/es/table';
import { Error } from "../components/Error.component";
import { useGetApplicationsQuery, useGetApplicationsUserCountQuery } from "../api/api";
import Spinner from "../components/Spinner";
import { Card, Space, Table, Select, Row, Col } from "antd";
import SearchBox from "../components/SearchBox";
import '../MuseDashboard.css';
import { Link } from "react-router-dom";

const { Option } = Select;

export const Applications = () => {
  const { data: userCountData } = useGetApplicationsUserCountQuery();
  const { data, error, isLoading } = useGetApplicationsQuery("");

  useEffect(() => {

}, [userCountData, data]);

  const [searchQuery, setSearchQuery] = useState("");
  const [selectedPublisher, setSelectedPublisher] = useState("");
  const [selectedVendor, setSelectedVendor] = useState("");
  const [selectedLicenseType, setSelectedLicenseType] = useState("");
  const [publishers, setPublishers] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [licenseTypes, setLicenseTypes] = useState([]);

  
  const mergedData = useMemo(() => {
    if (Array.isArray(data?.data) && Array.isArray(userCountData)) {
      return data.data.map(app => ({
        ...app,
        userCount: userCountData.find(userCount => userCount.appId === app.id)?.userCount || 0
      }));
    }
    return data?.data || [];
  }, [data, userCountData]);

  useEffect(() => {
    if (data) {
      setPublishers(Array.from(new Set(data.data.map(item => item.publishername_0))).sort());
      setVendors(Array.from(new Set(data.data.map(item => item.vendorname_0))).sort());
      setLicenseTypes(Array.from(new Set(data.data.map(item => item.typeoflicense_0))).sort());
    }
  }, [data]);

  const filterData = useMemo(() => {
    if (!data) return [];
    const query = searchQuery.toLowerCase();
    return mergedData.filter((item) => {
      const matchesSearchQuery = Object.values(item).some((value) =>
        String(value).toLowerCase().includes(query)
      );
      const matchesPublisher = selectedPublisher ? item.publishername_0 === selectedPublisher : true;
      const matchesVendor = selectedVendor ? item.vendorname_0 === selectedVendor : true;
      const matchesLicenseType = selectedLicenseType ? item.typeoflicense_0 === selectedLicenseType : true;
      return matchesSearchQuery && matchesPublisher && matchesVendor && matchesLicenseType;
    });
  }, [mergedData, searchQuery, selectedPublisher, selectedVendor, selectedLicenseType, data]);

  const totalCostYear = filterData.reduce((total, app) => total + Math.round(parseFloat(app.totallicensecostperannum_0) || 0), 0);

  const highestCostingLicense = useMemo(() => {
    const dataToUse = filterData.length ? filterData : mergedData;
    if (!dataToUse.length) return null;
    return dataToUse.reduce((prev, current) => {
      const prevCost = parseFloat(prev.totallicensecostperannum_0) || 0;
      const currentCost = parseFloat(current.totallicensecostperannum_0) || 0;
      return prevCost > currentCost ? prev : current;
    });
  }, [filterData, mergedData]);

  const totalLicenseCount = filterData.length;

  useEffect(() => {

}, [userCountData, data, mergedData]);


const columns: ColumnsType<any> = [
    { title: "Name", dataIndex: "licensename_0", key: "licensename_0", className: "table-cell-padding" },
    { title: "Publisher", dataIndex: "publishername_0", key: "publishername_0", className: "table-cell-padding" },
    { title: "License Type", dataIndex: "typeoflicense_0", key: "typeoflicense_0", sorter: (a, b) => a.utilization - b.utilization, className: "table-cell-padding" },
  
    {
      title: "Usage Count",
      dataIndex: "usageCount",
      key: "usageCount",
      sorter: (a, b) => a.usageCount - b.usageCount,
      render: (value) => (
        <div style={{ textAlign: 'right' }}>
          {value.toLocaleString()}
        </div>
      ),
      className: "table-cell-padding"
    },
    
    {
      title: "Purchased Quantity",
      dataIndex: "quantitypurchasedlicenses_0",
      key: "quantity",
      sorter: (a, b) => a.quantity - b.quantity,
      render: (value) => (
        <div style={{ textAlign: 'right' }}>
          {value.toLocaleString()}
        </div>
      ),
      className: "table-cell-padding"
    },

    {
      title: "Utilization (%)",
      key: "utilizationPercentage",
      sorter: (a, b) => {
        const aUtilization = parseFloat(a.usageCount);
        const aPurchased = parseFloat(a.quantitypurchasedlicenses_0);
        const aPercentage = aPurchased ? Math.round((aUtilization / aPurchased) * 100) : 0;
        const bUtilization = parseFloat(b.usageCount);
        const bPurchased = parseFloat(b.quantitypurchasedlicenses_0);
        const bPercentage = bPurchased ? Math.round((bUtilization / bPurchased) * 100) : 0;
        return aPercentage - bPercentage;
      },
      render: (text, record) => {
        const utilization = parseFloat(record.usageCount);
        const purchased = parseFloat(record.quantitypurchasedlicenses_0);
        const percentage = purchased ? Math.round((utilization / purchased) * 100) : 0;
        let color = "green";
        let fontWeight = "normal";
        if (percentage >= 90) {
          color = "red";
          fontWeight = "bold";
        } else if (percentage >= 80) {
          color = "orange";
        }
        return (
          <div style={{ textAlign: 'right', color, fontWeight }}>
            {`${percentage}%`}
          </div>
        );
      },
      className: "table-cell-padding"
    },
    

      {
        title: "Total cost (Year)",
        dataIndex: "totallicensecostperannum_0",
        key: "totallicensecostperannum_0",
        render: (value) => (
          <div style={{ textAlign: 'right' }}>
            {`$${Math.round(parseFloat(value)).toLocaleString()}`}
          </div>
        ),
        sorter: (a, b) => a.totallicensecostperannum_0 - b.totallicensecostperannum_0,
        className: "table-cell-padding"
      },
      
    
    { title: "Actions", dataIndex: "actions", key: "actions", render: (text, row) => <Link to={`/applications/${row.id}`}>Details</Link> },
  ];
  
  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };

  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });

  return (
    <div className="montserrat-font">
      {isLoading && <Spinner />}
      {error && <Error error={"Oops!"} />}
      {data && !error && (
        <Space direction="vertical" size="middle" style={{ display: "flex" }}>
          <Row gutter={16}>
            <Col span={8}>
              <Card className="muse-card equal-height-card">
              <h3>Total license cost </h3>
<h3><p><strong>${totalCostYear.toLocaleString()} / Year</strong></p></h3>
<h4><em>* Group & Assigned licenses</em></h4>
              </Card>
            </Col>
            <Col span={8}>
  <Card className="muse-card equal-height-card">
    <h3>Highest Costing License</h3>
    {highestCostingLicense ? (
      <>
        <h3><p><strong>{highestCostingLicense.vendorname_0} : {highestCostingLicense.licensename_0}</strong></p></h3>
        <h3><p><strong>${Math.round(parseFloat(highestCostingLicense.totallicensecostperannum_0)).toLocaleString()} / Year</strong></p></h3>
      </>
    ) : (
      <h3><p><strong>No data available</strong></p></h3>
    )}
  </Card>
</Col>

            <Col span={8}>
              <Card className="muse-card equal-height-card">
              <h3>Total License Count (Line Items) </h3>
                <h3><p><strong>{totalLicenseCount}</strong></p></h3>
              </Card>
            </Col>
          </Row>
          <Card className="muse-card">
          <Space direction="horizontal" size="middle" style={{ marginBottom: 16 }}>
  <SearchBox onSearch={setSearchQuery} />
  <Select placeholder="Filter by Publisher" style={{ width: 200 }} onChange={setSelectedPublisher} allowClear>
    {publishers.map((publisher) => (
      <Option key={publisher} value={publisher}>{publisher}</Option>
    ))}
  </Select>
  <Select placeholder="Filter by Vendor" style={{ width: 200 }} onChange={setSelectedVendor} allowClear>
    {vendors.map((vendor) => (
      <Option key={vendor} value={vendor}>{vendor}</Option>
    ))}
  </Select>
  <Select placeholder="Filter by License Type" style={{ width: 200 }} onChange={setSelectedLicenseType} allowClear>
    {licenseTypes.map((type) => (
      <Option key={type} value={type}>{type}</Option>
    ))}
  </Select>
</Space>



<Table
  dataSource={filterData}
  rowKey="id"
  columns={columns}
  className="montserrat-font"
  rowClassName={() => "table-row-spacing"}
  pagination={{
    ...pagination,
    showSizeChanger: true,
    pageSizeOptions: ['10', '20', '50', '100'],
    defaultPageSize: 10,
  }}
  onChange={handleTableChange}
/>
          </Card>
        
        </Space>
      )}
    </div>
  );
};
